import   React           , 
       { useState        , 
	     useEffect       }  from 'react';
		 
import   classNames         from 'classnames';

import   styles             from './ProductRow.module.scss';

import   Toggle             from '../../widget/inputs/Toggle';
import   Icon               from '../../widget/images/Icon';


import { Product         ,
         ProductCategory }  from '../../../dataTypes/productManagment/types';

import { WWW_URLS        }  from '../../../backendServices/urls';


interface ProductRowProps {
  product            : Product;
  productCategories  : ProductCategory[];
  index              : number;
  onEdit             : (index: number) => void;
  onDelete           : (product: Product) => void;
  onVisibilityToggle : (id: number) => void;
}

export const ProductRow = ({ product            ,
                             productCategories  ,
                             index              ,
                             onEdit             ,
                             onDelete           ,
                             onVisibilityToggle }: ProductRowProps) => {
  

const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    const fetchImage = async () => {
      const url = `${WWW_URLS.MediaServer}${product.publicRef}/images/thumbnail.webp`  //await searchImage(product);
      setImageUrl(url);
    };
    fetchImage();
  }, [product]);
  
  
  const renderCategories = (): JSX.Element => {

    const elements: JSX.Element[] = [];

    for (let l = 0; l < productCategories.length; l++) 
	 {
	  if (product.categoriesIds.includes(productCategories[l].id))
	   {
        elements.push ( <div> {productCategories[l].name} </div> );
       }
     }
	 
    return ( <> {elements} </> )
  };

  const getProductTypeIconName = () => {
	  
    switch (product.kind)
	 {
      case 'Physical Item'          : return "deliveryBox";
      case 'Subscription'           : return "subscription";
      case "PayVideo"               : return "filmStrip";
      case "PayChannel"             : return "TV";
      case "Urban Tour Masterclass" : return "TV";
      case "CreatorCapacity"        : return "subscription";
      default                       : return "void";
     }
  };
  
  return (

    <div className={classNames(styles.row)}>

      <div className={classNames(styles.column_1, styles.standard)}>
        <Icon name={getProductTypeIconName()} height={40} width={40} hoverable={false} clickable={false} />
      </div>
	  
      <div className={classNames(styles.column_2, styles.standard)}>
	    {
          imageUrl
          ?
           (
            <img src       = {imageUrl}
                 alt       = {product.name}
                 className = {styles.thumbnail}
                 onError   = {(e) => (e.currentTarget.style.display = 'none')} />
           )
          :
          null
	    }
      </div>
	  
      <div className={classNames(styles.column_3, styles.standard)}>
        {product.name}
      </div>
	  
      <div className={classNames(styles.column_4, styles.enum, styles.standard)}>
        {renderCategories()}
      </div>
	  
      <div className={classNames(styles.column_5, styles.standard)}>
        {
		 product.active && product.kind !== 'Subscription' && product.kind !== 'CreatorCapacity' &&
		 (
          <a href      = {`${WWW_URLS.customer_front}/produit?ref=${product.code}`}
             target    = "_blank"
             rel       = "noopener noreferrer"
             className = {styles.productLink} >
            {`${WWW_URLS.customer_front}/produit?ref=${product.code}`}
          </a>
         )
		}
      </div>
	  
      <div className={classNames(styles.column_6, styles.standard)}>
        {
         product.variants.length > 0 && product.variants[0].prices.length > 0
         ?
         `${product.variants[0].prices[0].basePrice.toFixed(2)} €`
         :
         null
        }
      </div>
      <div className={classNames(styles.column_7, styles.standard)}>
        {
         product.variants.length > 0 && product.variants[0].prices.length > 0
         ?
         `${product.variants[0].prices[0].priceWithTax.toFixed(2)} €`
         :
         null
        }
      </div>
        {/*
      <div className={classNames(styles.column_8, styles.standard)}>
         product.kind === "Physical Item"
         ?
          (product.variants[0].stockAvailable ? `${product.variants[0].stockAvailable}` : null)
         :
         null
      </div> 
        */}
      <div className={classNames(styles.column_9, styles.standard)}>
        <Icon name       = "pen"
              onClick    = {() => onEdit(index)}
		      color      = "var(--color-Icon-FG)"
              hoverColor = "var(--color-Icon-hover-FG)" />
        <Icon name       = "trashCan"
              onClick    = {() => onDelete(product)}
		      color      = "var(--color-Icon-FG)"
              hoverColor = "var(--color-Icon-hover-FG)" />
      </div>
      <div className={classNames(styles.column_10, styles.standard)}>
        <Toggle checked  = {product.active}
                form     = "bullet"/>
      </div>
      <div className={classNames(styles.column_11, styles.standard)}>
        <Toggle checked  = {product.publicPortal}
                form     = "bullet"/>
      </div>    </div>
  );
};

export default ProductRow;
